import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Table from 'shared/ui/Table/Table';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import {getHttpMonitorLogColumns} from 'features/http/lib/httpMonitorLogView';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorLogs from 'features/http/model/useHttpMonitorLogs';

import HttpMonitorSectionTitle from './HttpMonitorSectionTitle/HttpMonitorSectionTitle';
import HttpMonitorLogRow from '../HttpMonitorLogs/HttpMonitorLogRow';

import styles from './HttpMonitorDetails.module.scss';

interface IHttpMonitorLogsProps {
    monitor: IHttpMonitorItem,
}

const HttpMonitorLogs: React.FC<IHttpMonitorLogsProps> = ({monitor}) => {
    const {pagination, isLoading, dateRange, tzString} = useHttpMonitorLogs(monitor.uuid, false);

    return (
        <TableBox>
            <HttpMonitorSectionTitle title={t`Журнал`} name={monitor.name}/>
            <div className={cn(
                styles.dateRangeInfo,
                styles.color,
            )}>
                {dateRange}
            </div>
            <Table
                columns={getHttpMonitorLogColumns()}
                items={pagination?.items}
                rowFactory={item => <HttpMonitorLogRow
                    key={item.checked_at}
                    item={item}
                    tzString={tzString}
                />}
                isLoading={isLoading}
            />
        </TableBox>
    );
};

export default HttpMonitorLogs;
